import React, { useEffect, useTransition } from "react";

import { css } from "@emotion/react";
import ChattingRoomInfo from "@src/components/auctionAgent/chatting/chattingRoomInfo";
import ChattingChannel from "@src/components/auctionAgent/chatting/chattingChannel";

import SendbirdChat from "@sendbird/chat";
import { GroupChannelHandler, GroupChannelModule, SendbirdGroupChat } from "@sendbird/chat/groupChannel";
import { useSendBirdChat } from "@src/contexts/SendBirdChatContext";
import { WebAppBridge } from "@src/lib/WebAppBridge";
import { useChattingRoomFromContext } from "@src/contexts/ChattingRoomContext";

import { useReadMsgMessage, useReadSendbirdMessage } from "@src/hooks/auctionAgent/chat";
import { useQueryClient } from "react-query";

const SEND_BIRD_APP_ID = process.env.REACT_APP_SEND_BIRD_APP_ID!;

const HANDLER_ID = "MY_CHANNEL_HANDLER";

const AuctionAgentChatting = () => {
    const [isPending, startTransition] = useTransition();
    const queryClient = useQueryClient();
    const { setSendBirdMessages, setReadStatusMap, msgMessages } = useSendBirdChat();
    const { chattingRoomFromContext, setChattingRoomFromContext } = useChattingRoomFromContext();
    const { mutate: readMsgMessage } = useReadMsgMessage();
    const { mutate: readSendbirdMessage } = useReadSendbirdMessage();

    useEffect(() => {
        // 메시지 읽음 발신 (MSG ) - 수신 ( onUnreadMemberStatusUpdated)
        if (!chattingRoomFromContext?.chattingRoomNo) return;
        if (msgMessages.length > 0) {
            console.log("📈메시지가 변경되었어요", msgMessages);
            // 상대방 메시지 중 가장 최근 메시지
            const opponentLastMsg = msgMessages.sort((a, b) => b.no - a.no)[0];
            if (opponentLastMsg && !opponentLastMsg.isRead) {
                readMsgMessage(
                    { chattingRoomNo: chattingRoomFromContext?.chattingRoomNo, messageNo: opponentLastMsg.no },
                    {
                        onSuccess: () => {
                            console.log("✅ channel markAsRead");
                        },
                        onError: (error) => {
                            console.error("❌ channel markAsRead error", error);
                        },
                    },
                ); // Msg 읽음 처리
            }
        }
    }, [msgMessages, chattingRoomFromContext?.chattingRoomNo]);

    // const getChannel = async ({ user, channelUrl, chattingRoomNo }: onEnterChattingParams) => {
    //     // sendbird 연결
    //     const sb = SendbirdChat.init({
    //         appId: SEND_BIRD_APP_ID,
    //         modules: [new GroupChannelModule()],
    //     }) as SendbirdGroupChat;
    //     await sb.connect(user.userId);
    //     const channel = await sb.groupChannel.getChannel(channelUrl);
    //     console.log("✅ channel ready", channel);

    //     // 채널 핸들러 설정
    //     const groupChannelGlobalHandler = new GroupChannelHandler();

    //     groupChannelGlobalHandler.onMessageReceived = (channel, message) => {
    //         if (channel.url !== channelUrl) return;

    //         console.log("📩 메시지 수신 (해당 채널):", message);

    //         if (message.isUserMessage()) {
    //             startTransition(() => {
    //                 setSendBirdMessages((prev) => [...prev, message]);
    //             });
    //             if (message.sender.userId !== user.userId) {
    //                 queryClient.invalidateQueries(["msgMessages"]);
    //                 setTimeout(() => {
    //                     readSendbirdMessage({
    //                         chattingRoomNo,
    //                         sendbirdMessageId: message.messageId.toString(),
    //                     });
    //                 }, 500);
    //             }
    //         }
    //     };
    //     groupChannelGlobalHandler.onUnreadMemberStatusUpdated = (channel) => {
    //         if (channel.url !== channelUrl) return;

    //         // If includeAllMembers is set to false, the results won't include the current user.
    //         const result = channel.getReadStatus(false);

    //         if (result) {
    //             console.log("💣 읽음 상태 변경:", result);
    //             startTransition(() => {
    //                 setReadStatusMap(result);
    //             });
    //         }
    //     };

    //     sb.groupChannel.addGroupChannelHandler(HANDLER_ID, groupChannelGlobalHandler);
    // };

const getChannel = async ({ user, channelUrl, chattingRoomNo }: onEnterChattingParams) => {
    try {
        // 1. Sendbird 초기화
        const sb = SendbirdChat.init({
            appId: SEND_BIRD_APP_ID,
            modules: [new GroupChannelModule()],
        }) as SendbirdGroupChat;

// 1. 혹시 남아있을지 모르는 연결이나 세션을 강제로 종료
        await sb.disconnect(); 
        
        // 2. 다시 연결 시도
        console.log("새로운 연결 시도:", user.userId);
        await sb.connect(user.userId);
     
        
        console.log("✅ Sendbird 연결 성공");

        // 3. 채널 정보 가져오기
        const channel = await sb.groupChannel.getChannel(channelUrl);
        console.log("✅ 채널 로드 완료:", channel.url);

        // 4. 채널 핸들러 설정
        const groupChannelGlobalHandler = new GroupChannelHandler();

        groupChannelGlobalHandler.onMessageReceived = (channel, message) => {
            if (channel.url !== channelUrl) return;

            console.log("📩 메시지 수신:", message);

            if (message.isUserMessage()) {
                startTransition(() => {
                    setSendBirdMessages((prev) => [...prev, message]);
                });
                
                if (message.sender.userId !== user.userId) {
                    queryClient.invalidateQueries(["msgMessages"]);
                    setTimeout(() => {
                        readSendbirdMessage({
                            chattingRoomNo,
                            sendbirdMessageId: message.messageId.toString(),
                        });
                    }, 500);
                }
            }
        };

        groupChannelGlobalHandler.onUnreadMemberStatusUpdated = (channel) => {
            if (channel.url !== channelUrl) return;

            const result = channel.getReadStatus(false);
            if (result) {
                console.log("💣 읽음 상태 변경:", result);
                startTransition(() => {
                    setReadStatusMap(result);
                });
            }
        };

        // 기존 핸들러가 있다면 제거 후 등록 (중복 방지)
        sb.groupChannel.removeGroupChannelHandler(HANDLER_ID);
        sb.groupChannel.addGroupChannelHandler(HANDLER_ID, groupChannelGlobalHandler);

    } catch (error: any) {
        // 🚨 에러 핸들링
        console.error("❌ Sendbird 에러 발생:");
        console.error("Error Code:", error.code); // 400111 등이 찍히면 토큰 문제입니다.
        console.error("Error Message:", error.message);

        // 환경별 대응을 위한 조건문 예시
        if (error.code === 400111) {
            console.error("보안 정책상 토큰이 필수인 유저입니다. 백엔드에서 발급한 토큰을 확인하세요.");
        }
        
        // 필요하다면 사용자에게 알림 처리를 추가하세요.
    }
};

    WebAppBridge.onEnterChatting = (params: string) => {
        getChannel(JSON.parse(params) as onEnterChattingParams);
        setChattingRoomFromContext(JSON.parse(params) as onEnterChattingParams);
        console.log("✅ WebAppBridge.onEnterChatting", JSON.parse(params));
    };

    //  테계 8
    // useEffect(() => {
    //     getChannel({
    //         chattingRoomNo: 605,
    //         channelUrl: "match_1_e06e0c21-1d91-45ae-b7cf-c4cefd4b49ef",
    //         user: { userId: "793f2500-606e-46b1-8dda-4afe5fb3ff53", userType: "user" },
    //         serviceType: MatchServiceType.경매대행,
    //     });
    //     setChattingRoomFromContext({
    //         chattingRoomNo: 605,
    //         channelUrl: "match_1_e06e0c21-1d91-45ae-b7cf-c4cefd4b49ef",
    //         user: { userId: "793f2500-606e-46b1-8dda-4afe5fb3ff53", userType: "user" },
    //         serviceType: MatchServiceType.경매대행,
    //     });
    // }, []);

    return (
        <div css={rootBoxStyle}>
            <div css={chattingRoomInfoBoxStyle}>
                <ChattingRoomInfo />
                <ChattingChannel />
            </div>
        </div>
    );
};

export default AuctionAgentChatting;

const rootBoxStyle = css`
    width: 100%;
    height: 100vh;
    position: relative;

    & > img {
        width: 100%;
    }
`;

const chattingRoomInfoBoxStyle = css`
    width: 100%;
    height: 100%;
    position: sticky;
    top: 0;
    left: 0;
`;

export type onEnterChattingParams = {
    chattingRoomNo: number;
    user: { userId: string; userType: "user" | "taker" };
    channelUrl: string;
    serviceType: MatchServiceType;
};

export enum MatchServiceType {
    "경매대행" = 1, // 매물컨설팅 + 매수신청대리에 해당
    "매수신청대리" = 2,
    "매물컨설팅" = 3,
    "임장동행" = 4,
}
